import React, { useEffect, useState } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import { ManageOrderReports } from "./logic";
import {
  showMessage,
  getToken,
  ManageRestaurant,
  formatAMPM,
} from "../../Functionalities/Functions";
import axios from "axios";
import FilterComponent from "../../CoreComponents/FilterComponent";
import FilterModalComponent from "../../CoreComponents/FilterModalComponent";
import {
  is_franchise_admin,
  is_franchise_manager,
  is_franchise_staff,
  is_superuser,
  protocol,
} from "../../Functionalities/Config";
import NoDataComponent from "../../CoreComponents/NoDataComponent";
import { url } from "../../Functionalities/Config";
import LoadingComponent from "../../CoreComponents/LoadingComponent";
function Body() {
  const [data, setData] = useState({ id: "", name: "", data: [] });
  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");
  const [loading, setLoading] = useState(true);
  const [filter, setfilter] = useState({
    branch_id: "",
    order_id: "FDR",
    from_date: "",
    to_date: "",
    search_text: "",
  });
  const [restrarent, setrestrarent] = useState({ id: "", name: "", data: [] });

  const [adminTransaction, setadminTransaction] = useState({
    id: "",
    name: "",
    data: [],
  });
  const [branchTransaction, setbranchTransaction] = useState({
    id: "",
    name: "",
    data: [],
  });

  useEffect(() => {
    fetchData();
    (is_franchise_admin || is_franchise_manager || is_franchise_staff) &&
      getBranches();
    (is_franchise_admin || is_franchise_manager || is_franchise_staff) &&
      getSuperAdminTransition();
    !(is_franchise_admin || is_franchise_manager || is_franchise_staff) &&
      getBranchTransactions();
  }, []);

  let params =
    "branch_id=" +
    filter.branch_id +
    "&order_id=" +
    filter.order_id.substr(3) +
    "&from_date=" +
    filter.from_date +
    "&to_date=" +
    filter.to_date +
    "&search_text=" +
    filter.search_text;

  const getSuperAdminTransition = () => {
    let url1 =
      filter.branch_id === ""
        ? url + "/accounts/branchbalance/"
        : url +
          "/accounts/branchbalance/?keyword=branch_balance&branch_id=" +
          filter.branch_id;
    var config = {
      method: "get",
      url: url1,
      headers: {
        Authorization: getToken(),
      },
    };
    axios(config)
      .then(function (response) {
        setadminTransaction({
          ...adminTransaction,
          data: response.data,
          name: filter.branch_id === "" ? "admin" : "branch",
        });
      })
      .catch(function (error) {
        // void 0
      });
  };

  const getBranchTransactions = () => {
    var config = {
      method: "get",
      url: url + "/accounts/branchbalance/",
      headers: {
        Authorization: getToken(),
      },
    };
    axios(config)
      .then(function (response) {
        setbranchTransaction({
          ...branchTransaction,
          data: response.data,
        });
      })
      .catch(function (error) {
        // void 0
      });
  };

  const fetchData = () => {
    let result = ManageOrderReports("", "", "get", params);
    result.then((result) => {
      setData({
        ...data,
        data: result.data.results,
      });
      setLoading(false);
      setNext(result.data.next);
      setPrev(result.data.previous);
    });
  };

  const handlePrev = () => {
    // alert("prev");
    var config = {
      method: "get",
      url: prev.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleNext = () => {
    //alert("next")
    var config = {
      method: "get",
      url: next.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const getBranches = () => {
    showMessage(
      "Loading Restaurant",
      "info",
      "Loading",
      "bottom",
      "bottom-left",
      0
    );

    let params = "for_dropdown=true&page_wise=false";

    let result = ManageRestaurant("", "", "get", params);
    result
      .then((result) => {
        // showMessage(
        //   JSON.stringify(result),
        //   "success",
        //   "Loading",
        //   "top",
        //   "top-center",
        //   0
        // );
        setrestrarent({
          ...restrarent,
          data: result?.data,
        });
      })
      .catch((err) => {
        showMessage(
          JSON.stringify(err),
          "danger",
          "Loading error",
          "top",
          "top-center",
          0
        );
        // void 0
      });
  };
  var total_commission_percentage;
  const commissionPercentageCalculation = (data) => {
    // void 0
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total = total + data[i].commission_percentage;
    }

    total = total / data.length;
    // void 0
    return total;
  };
  return (
    <div class="content-body">
      {!loading ? (
        <div class="container-fluid">
          <FilterModalComponent
            heading={"Filter Order Reports"}
            fromDateValue={filter.from_date.slice(0, 10)}
            fromDateChange={(e) => {
              setfilter({
                ...filter,
                from_date: e.target.value + " 00:00:00",
              });
            }}
            toDateValue={filter.to_date.slice(0, 10)}
            toDateChange={(e) => {
              setfilter({
                ...filter,
                to_date: e.target.value + " 00:00:00",
              });
            }}
            searchItemValue={filter.search_text}
            searchItemChange={(e) =>
              setfilter({
                ...filter,
                search_text: e.target.value,
              })
            }
            clearFilter={(e) => {
              e.preventDefault();
              window.location.reload();
            }}
            submitFilter={(e) => {
              e.preventDefault();
              fetchData();
              (is_franchise_admin ||
                is_franchise_manager ||
                is_franchise_staff) &&
                getSuperAdminTransition();
            }}
          >
            {(is_franchise_admin ||
              is_franchise_manager ||
              is_franchise_staff) && (
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Restaurant <span className="required"></span>
                  </label>
                  <select
                    value={filter.branch_id}
                    class="form-control form-control-lg"
                    onChange={(e) =>
                      setfilter({
                        ...filter,
                        branch_id: e.target.value,
                      })
                    }
                  >
                    <option value={""} id={""}>
                      All
                    </option>
                    {restrarent?.data?.map((item) => (
                      <option value={item.id} id={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            <div className="col-lg-6">
              <div className="form-group">
                <label className="text-black font-w600">
                  Order ID <span className="required"></span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  placeholder="Order Id"
                  value={filter.order_id}
                  onChange={(e) =>
                    setfilter({
                      ...filter,
                      order_id: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </FilterModalComponent>

          {data.data.length > 0 ? (
            <>
              <FilterComponent
                handleNext={handleNext}
                handlePrev={handlePrev}
                next={next}
                prev={prev}
                filterButtonName={"Filter"}
                export={data.data}
                type="Order"
              />

              <div className="col-lg-12">
                <div className="form-group">
                  <h4 className="fs-20 font-w600 text-center">
                    Total Transactions Amount
                  </h4>

                  <div className="row" style={{ marginTop: 10 }}>
                    <div className="table-responsive rounded card text-center">
                      <table
                        className="table border-no order-table mb-4 table-responsive-lg dataTablesCard"
                        id="example5"
                      >
                        <thead>
                          <tr>
                            <th>Transaction</th>
                            {adminTransaction.name === "admin" && (
                              <>
                                <th>Cash in hand</th>
                                <th>Paid</th>
                                <th>Balance amount</th>
                                <th>Commission amount</th>
                              </>
                            )}
                            {adminTransaction.name === "branch" && (
                              <>
                                <th>Cash in hand</th>
                                <th>Paid</th>
                                <th>Commission amount</th>
                                <th>Balance amount</th>
                              </>
                            )}
                            {!(
                              is_franchise_admin ||
                              is_franchise_manager ||
                              is_franchise_staff
                            ) &&
                              branchTransaction.data && (
                                <>
                                  <th>Remaining amount</th>
                                  <th>Received amount</th>
                                  <th>Balance amount</th>
                                </>
                              )}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Amount</td>
                            {adminTransaction.name === "admin" && (
                              <>
                                <td>
                                  ₹ {adminTransaction.data.total_amount_in}
                                </td>
                                <td>
                                  ₹ {adminTransaction.data.total_amount_out}
                                </td>
                                <td>
                                  ₹ {adminTransaction.data.total_balance_amount}
                                </td>
                                <td>
                                  ₹{" "}
                                  {
                                    adminTransaction.data
                                      .total_commission_amount
                                  }
                                </td>
                              </>
                            )}
                            {adminTransaction.name === "branch" && (
                              <>
                                <td>
                                  ₹{" "}
                                  {adminTransaction.data.total_remaining_amount}
                                </td>
                                <td>
                                  ₹ {adminTransaction.data.total_recived_amount}
                                </td>
                                <td>
                                  ₹{" "}
                                  {
                                    adminTransaction.data
                                      .total_commission_amount
                                  }
                                </td>
                                <td>
                                  ₹ {adminTransaction.data.total_balance_amount}
                                </td>
                              </>
                            )}

                            {!(
                              is_franchise_admin ||
                              is_franchise_manager ||
                              is_franchise_staff
                            ) &&
                              branchTransaction.data && (
                                <>
                                  <td>
                                    ₹{" "}
                                    {
                                      branchTransaction.data
                                        .total_remaining_amount
                                    }
                                  </td>
                                  <td>
                                    ₹{" "}
                                    {
                                      branchTransaction.data
                                        .total_recived_amount
                                    }
                                  </td>
                                  <td>
                                    ₹{" "}
                                    {
                                      branchTransaction.data
                                        .total_balance_amount
                                    }
                                  </td>
                                </>
                              )}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12">
                  <div className="table-responsive rounded card-table">
                    <div
                      id="example5_wrapper"
                      class="dataTables_wrapper no-footer"
                    >
                      <table
                        className="table border-no order-table mb-4 table-responsive-lg dataTablesCard"
                        id="example5"
                      >
                        <thead>
                          <tr>
                            <th>REPORT ID</th>
                            <th>DATE</th>
                            {/* <th>Name</th> */}
                            <th>NET AMOUNT</th>
                            <th>COMMISSION PERCENTAGE</th>
                            {(is_franchise_admin ||
                              is_franchise_manager ||
                              is_franchise_staff) && <th>COMMISSION AMOUNT</th>}
                            <th>REMAINING AMOUNT</th>
                            {/* <th>DESCRIPTION</th> */}
                            <th>ORDER ID</th>
                            {(is_franchise_admin ||
                              is_franchise_manager ||
                              is_franchise_staff) && <th>RESTAURANT</th>}
                            {/* <th>Paid Amt</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {data.data.map((report, index) => {
                            return (
                              <tr
                                className="alert alert-dismissible border-0"
                                key={index}
                              >
                                <td>
                                  {/* <a href={`/orderID/${item.id} `}> #{item.id}</a> */}
                                  ORRPT{report.id}
                                </td>

                                <td>
                                  {new Date(report.date).toLocaleDateString()}
                                  <br />
                                  {formatAMPM(new Date(report.date))}
                                </td>
                                <td>
                                  <b class="text text-primary">
                                    ₹ {report.net_amount}
                                  </b>
                                </td>
                                <td>
                                  <b class="text text-secondary">
                                    {report.commission_percentage}%
                                  </b>
                                </td>
                                {(is_franchise_admin ||
                                  is_franchise_manager ||
                                  is_franchise_staff) && (
                                  <td>
                                    <b class="text text-success">
                                      ₹ {report.commission_amount}
                                    </b>
                                  </td>
                                )}
                                <td>
                                  <b class="text text-danger">
                                    ₹ {report.remaining_amount}
                                  </b>
                                </td>
                                {/* <td>{report.discription}</td> */}

                                <td>
                                  {report.order ? (
                                    <a href={`/orderID/${report.order}`}>
                                      <h5 className="mb-0 fs--1">
                                        {"FDR" + report.order}
                                      </h5>
                                    </a>
                                  ) : (
                                    <h5 className="mb-0 fs--1">--</h5>
                                  )}
                                </td>
                                {(is_franchise_admin ||
                                  is_franchise_manager ||
                                  is_franchise_staff) && (
                                  <td>
                                    <a
                                      href={`/restaurant/${report.branch.id} `}
                                    >
                                      <h5 className="mb-0 fs--1">
                                        {report.branch.name}
                                      </h5>
                                    </a>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                        </tbody>

                        {data.data.length > 0 && (
                          <thead>
                            <tr>
                              <th>Total</th>
                              <th>---</th>

                              <th>
                                ₹
                                {data.data
                                  .reduce(function (tot, arr) {
                                    return tot + arr.net_amount;
                                  }, 0)
                                  .toFixed(2)}
                              </th>

                              {(is_franchise_admin ||
                                is_franchise_manager ||
                                is_franchise_staff) && (
                                <th>
                                  {data.data.length > 0
                                    ? (total_commission_percentage =
                                        commissionPercentageCalculation(
                                          data.data
                                        ).toFixed(2))
                                    : 0}
                                  %
                                </th>
                              )}

                              {!(
                                is_franchise_admin ||
                                is_franchise_manager ||
                                is_franchise_staff
                              ) ? (
                                <th>
                                  {data.data[0].commission_percentage} % ( ₹{" "}
                                  {data.data
                                    .reduce(function (tot, arr) {
                                      return tot + arr.commission_amount;
                                    }, 0)
                                    .toFixed(2)}
                                  )
                                </th>
                              ) : (
                                <th>
                                  ₹{" "}
                                  {data.data
                                    .reduce(function (tot, arr) {
                                      return tot + arr.commission_amount;
                                    }, 0)
                                    .toFixed(2)}
                                </th>
                              )}
                              <th>
                                ₹
                                {data.data
                                  .reduce(function (tot, arr) {
                                    return tot + arr.remaining_amount;
                                  }, 0)
                                  .toFixed(2)}
                              </th>
                              <th>---</th>
                              {(is_franchise_admin ||
                                is_franchise_manager ||
                                is_franchise_staff) && <th>---</th>}
                            </tr>
                          </thead>
                        )}
                      </table>
                      <div
                        class="dataTables_paginate paging_simple_numbers"
                        id="example5_paginate"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <NoDataComponent data="transactions found" />
          )}
        </div>
      ) : (
        <LoadingComponent />
      )}
    </div>
  );
}

function Orderreports() {
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header
          name={"Order Reports"}
          subHeading={"All  Orders Transaction Reports"}
        />
        <NavBar />
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default Orderreports;
